/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { FilterInOp } from './filterInOp';

export interface FilterIn {
  column: string;
  op: FilterInOp;
  value?: unknown;
}
